// extracted by mini-css-extract-plugin
module.exports = {"className":"ta-IN_className__x0QH5"};